import { render, staticRenderFns } from "./arrowhead.vue?vue&type=template&id=70990ac0&scoped=true&v-once=true"
import script from "./arrowhead.vue?vue&type=script&lang=js"
export * from "./arrowhead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70990ac0",
  null
  
)

export default component.exports